import {
  IconBookmark,
  IconBuildings,
  IconCoil,
  IconEnergyCircle,
  IconInfo,
  IconMeter,
  IconPencil,
  IconPenSquare,
  IconPlug,
  IconPower,
  IconRuler,
  IconSearch,
  IconShare,
  IconShareGray,
  IconSignal,
  IconTools,
  IconUpload,
} from '@assets/images/icon';
import { IconAnalyze, IconFacetime, IconTopology, schemeAoa, schemeBle, schemeComfort, schemeUwb } from '@assets/images/main';
import { accessAuto1, accessAutoMain, accessPro1, accessProMain, accesscontroller1, accesscontrollerMain } from '@assets/images/main/access/product';
import { vehicleTrackingKit1, vehicleTrackingKit5, yardTrackingKit1, yardTrackingKit4 } from '@assets/images/main/outdoor';

export default {
  a: [
    { text: 'Technology Type', icon: IconInfo },
    { text: 'Location Accuracy', icon: IconSignal },
    { text: 'Transmission Interval', icon: IconUpload },
    { text: 'Integration Structure', icon: IconTopology },
    { text: 'Power Input', icon: IconPlug },
    { text: 'Recommended Environment', icon: IconBookmark },
    { text: 'Key Features', icon: IconPencil },
    { text: 'External Integration', icon: IconShare },
  ],

  b: [
    { text: 'GNSS-based GPS positioning' },
    { text: '±3 meters' },
    { text: 'Up to 30 times per minute' },
    { text: 'GPS Device (LTE) → ORBRO Server' },
    { text: 'USB-C' },
    { text: 'Vehicle tracking, asset tracking' },
    { text: 'Single device enables location tracking' },
    { text: 'API provided' },
  ],

  c: [
    { text: 'LoRA-based GPS signal reception' },
    { text: '±3 meters' },
    { text: 'Up to 120 times per minute' },
    { text: 'GPS Tag → LoRA Receiver → ORBRO Server' },
    { text: 'PoE' },
    { text: 'Yards, ports, logistics centers, construction sites, etc.' },
    { text: 'Receives multiple tag signals in specific areas,<br/>usable without communication costs' },
    { text: 'API provided (real-time events/location/status integration)' },
  ],

  spec: [
    {},

    {
      image: vehicleTrackingKit5,
      link: '/outdoor/gps',
      title: 'GPS Device',
      desc: '',
    },

    {
      image: yardTrackingKit4,
      link: '/outdoor/lora',
      title: 'GPS Tag (LoRA)',
      desc: '',
    },
  ],
};
